import React from "react";
import pluralize from "pluralize";
import PropTypes from "prop-types";

import ExpandableGrid from "../../../layout/ExpandableGrid/ExpandableGrid";
import propTypes from "../../../../constants/propTypes";
import SpecTable from "./SpecTable";
import {
  PriceCalculation,
  Title,
  Content,
  PriceCalculations,
} from "./components";
import useCurrencyFormatter from "../../../hooks/useCurrencyFormatter";

const Categories = ({ projectCategoryPrices, project, displayDiscount }) => {
  const currencyFormatter = useCurrencyFormatter();

  return projectCategoryPrices.map(
    (
      {
        totalSpec,
        specCategory,
        uncommittedPrice,
        committedPrice,
        total,
        totalPriceWithDiscount,
        salesTax = 0,
        forecastTotal,
        forecastTotalWithDiscount,
        additionalCostsTotal,
      },
      i
    ) => (
      <ExpandableGrid
        key={i}
        title={`${specCategory.name} (${totalSpec}
        ${pluralize("Spec", totalSpec)})`}
        expandableTitle="Specs"
        expandleContent={
          project ? (
            <SpecTable
              projectId={project.id}
              displayDiscount={displayDiscount}
              rootFilters={{
                specCategoryId: specCategory.id,
              }}
              dataComponentId={`specs-by-category-${specCategory.id}`}
            />
          ) : null
        }
      >
        <PriceCalculations>
          <PriceCalculation>
            <Title>Uncommitted</Title>
            <Content>{currencyFormatter.format(uncommittedPrice)}</Content>
          </PriceCalculation>
          <PriceCalculation>
            <Title>Committed</Title>
            <Content>{currencyFormatter.format(committedPrice)}</Content>
          </PriceCalculation>
          <PriceCalculation>
            <Title>Merchandise Cost</Title>
            <Content>
              {currencyFormatter.format(
                displayDiscount ? totalPriceWithDiscount : total
              )}
            </Content>
          </PriceCalculation>
          <PriceCalculation>
            <Title>Non-Merchandise Cost</Title>
            <Content>{currencyFormatter.format(additionalCostsTotal)}</Content>
          </PriceCalculation>
          <PriceCalculation>
            <Title>Sales Tax</Title>
            <Content>{currencyFormatter.format(salesTax)}</Content>
          </PriceCalculation>
          <PriceCalculation>
            <Title>Forecast</Title>
            <Content>
              {currencyFormatter.format(
                displayDiscount ? forecastTotalWithDiscount : forecastTotal
              )}
            </Content>
          </PriceCalculation>
        </PriceCalculations>
      </ExpandableGrid>
    )
  );
};

Categories.propTypes = {
  specs: PropTypes.arrayOf(propTypes.spec),
  project: propTypes.project,
  projectAreaPrices: PropTypes.arrayOf(PropTypes.object),
};

export default Categories;
